import React from "react";

export default function Label(props) {
  const { controleId, comp, stateData: data } = props;
  const attStyle = comp?.styleCss?.textalign || "";
  const cssClass = `${attStyle ? "text-" + attStyle : ""} ${comp?.cssclass || ""} form-group`;

  const stylecode = {
    fontSize: "14.5px",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
    fontWeight: 600,
    color: "#1e293b", 
  };


  const renderTextContent = () => {
    const lines = comp.text?.split("&lt;br&gt;") || [];
    const content = lines.map((item, idx) => (
      <React.Fragment key={idx}>
        {item}
        <br />
      </React.Fragment>
    ));

    if (comp.formIcons) {
      return (
        <div className="d-flex">
          <div>
            <span>
              <i className={`${comp.formIcons} p-1`} aria-hidden="true" />
            </span>
          </div>
          <div>{content}</div>
        </div>
      );
    }

    return <div>{content}</div>;
  };

  const resolvedContent = controleId !== "" ? data[controleId] : renderTextContent();

  const renderByType = (type) => {

    const commonSx = {
      fontSize: "14px",
      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
      fontWeight: 600,
      color: "#1e293b",
    };

    switch (type) {
      case "ol":
        return (
          <ol type={comp.orderedListType} style={commonSx}>
            {(comp.text?.split("&lt;br&gt;") || []).map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ol>
        );
      case "ul":
        return (
          <ul style={commonSx}>
            {(comp.text?.split("&lt;br&gt;") || []).map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        );
      case "paragraph":
        return <p style={{ ...commonSx, margin: 0, fontWeight: 400, color: "#334155" }}>{resolvedContent}</p>;
      case "label":
        return <span style={{ ...commonSx, fontWeight: 500, color: "#64748b" }}>{resolvedContent}</span>;
      case "h1":
        return <h1 style={{ fontSize: "1.625rem", fontWeight: "600", fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif", color:"#0f172a", margin: 0 }}>{resolvedContent}</h1>;
      case "h2":
        return <h2 style={{ fontSize: "1.25rem", fontWeight: "600", fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif", color:"#0f172a", margin: 0 }}>{resolvedContent}</h2>;
      case "h3":
        return <h3 style={{ fontSize: "1.0625rem", fontWeight: "600", fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif", color:"#0f172a", margin: 0 }}>{resolvedContent}</h3>;
      case "h4":
        return <h4 style={{ fontSize: "0.9375rem", fontWeight: "600", fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif", color:"#0f172a", margin: 0 }}>{resolvedContent}</h4>;
      case "h5":
        return <h5 style={{ fontSize: "0.875rem", fontWeight: "600", fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif", color:"#0f172a", margin: 0 }}>{resolvedContent}</h5>;
      default:
        return <div style={commonSx}>{resolvedContent}</div>;
    }
  };

  return (
    <div className={cssClass}>
      {comp?.attributeDataTypes
        ? renderByType(comp.attributeDataTypes.type)
        : (
          <div style={stylecode}>
            {resolvedContent}
          </div>
        )}
    </div>
  );
}
